import React from 'react';

const Exelibrary=()=>{
    return(
        <div>
            <h3>DIARIO ESERCIZI</h3>
            <div className="jumbotron"><h4>Coming soon...</h4></div>
        </div>
    )
}
export default Exelibrary;